import { useMutation } from 'react-query'
import { type TaskLinkAndUnlinkCollaboratorPersistence } from '../../../../types/persistence/task-link-and-unlink-collaborator-persistence'
import { api } from '../../../api'

const taskLinkCollaborator = async (id: number, data: TaskLinkAndUnlinkCollaboratorPersistence) => {
  const response = await api.put(`/tasks/${id}/link-collaborator`, data)
  return response.data
}

export const useTaskLinkCollaboratorMutation = () => {
  return useMutation({
    mutationFn ({ id, data }: { id: number, data: TaskLinkAndUnlinkCollaboratorPersistence }): Promise<any> {
      return taskLinkCollaborator(id, data)
    }
  })
}
